import { IStaff } from "./staff";
import { IServiceDoneDefinition, IServiceDone } from "./service-done";
import { IServiceTodoDefinition, IServiceDTO } from "./service-todo";
import { IWhoAmI, IPath } from "./user";
import { ICustTypeDto } from './customers';

export interface IAppList {
  name: string;
  icon: string;
  route: string;
  rol?: string;
}

export type TFormValidator = (arg: any) => boolean | string;

export type Callback = (...arg: any[]) => void;

export enum PriceType {
  Each = 0,
  Set = 10
}

export interface IPagedResultset {
  TotalRecords: number;
  Page?: number;
  PageSize?: number;
  MaxPage?: number;
  SortBy: string;
  SortAsc: boolean;
}

export interface IResponseBase {
  Ok: boolean;
  Msg: string;
  LoginRequired?: boolean;
}

export class ResponseBase {
  Ok: boolean = true;
  Msg: string = '';
  LoginRequired?: boolean;
}

export interface IAutocompleteOption {
  [key: string]: any;
}

export interface ILoadRequest {}

export interface ILoadResponse extends IResponseBase {
  Staff: IStaff[];
  ServicesDone: IServiceDoneDefinition[];
  ServicesToDo: IServiceTodoDefinition[];
  Paths: IPath[];
	WhoAmI: IWhoAmI;
	CustTypes: ICustTypeDto[];
	ServiceItems: IServiceDTO[];
	InvoiceTax: number;
	MaterialCharge: number;
}

export interface IRootState {
  appName: string;
  appVersion: string;
}

export interface ISnackbar {
  message: string;
  status: "success" | "error";
}




export class DialogConfig {
  public Title: string = "Alert";
  public Text: string = "Working...";
  // public Viz: boolean = true;
  public OkText: string = "Ok";
  public CancelText: string = "Cancel";
	public Callback: (result: boolean) => void;
	public ShowCancel: boolean=true;
}

export class BlockerConfig {
	public Text: string = "Working...";
	public Show: boolean=false;
}

